import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks';
import { Loading } from '../ui';
import { env } from '../../config';

export function RequireGuest({ children, redirectTo = '/dashboard' }) {
  // Always enable auth check to see if user is logged in
  // This prevents logged-in users from accessing login/guest pages
  const { data: user, isLoading, isFetching } = useAuth({ enabled: true });

  // If auth bypass is enabled, allow access to guest pages
  if (env.features.authBypass) {
    return <>{children}</>;
  }

  // Show loading while checking authentication status
  if (isLoading || isFetching) {
    return <Loading messageKey="auth.prepare" />;
  }

  // If user is authenticated, redirect to dashboard
  if (user) {
    return <Navigate to={redirectTo} replace />;
  }

  // User is not authenticated, allow access to guest pages (login)
  return <>{children}</>;
}
